import styled from 'styled-components';
import MUITable from '@material-ui/core/Table';
import Typography from '@material-ui/core/Typography';

export const Title = styled(Typography)`
  ${({ theme: { breakpoints } }) => `
    margin-bottom: 15px;

    ${breakpoints.up('md')} {
      margin-bottom: 20px;
    }
  `}
`;

export const Feature = styled(Typography)`
  ${({ theme: { colors } }) => `
    font-size: 10px;
    line-height: 15px;
    font-weight: 600;
    text-transform: uppercase;
    background-color: ${colors.greys.greys0};
    margin: 0 4px 4px 0;
    padding: 4px 5px;

    &:last-child {
      margin-right: 0;
    }
  `}
`;

export const Table = styled(MUITable)`
  ${({
    theme: {
      colors,
      typography: { body2 },
    },
  }) => `
    margin-top: 17px;
    .MuiTableCell-body {
      padding: 10px 0;
      font-size: ${body2.fontSize};
      line-height: ${body2.lineHeight};
      font-weight: ${body2.fontWeight};
      border-bottom: 1px solid ${colors.greys.greys3};

      &:first-child {
        opacity: 0.75;
      }
    }

    .MuiTableBody-root {
      &:last-child {
        .MuiTableRow-root {
          &:last-child {
            .MuiTableCell-body {
              border-bottom: none;
            }
          }
        }
      }

      .MuiTableRow-root {
        &:first-child {
          .MuiTableCell-body {
            border-top: 1px solid ${colors.greys.greys3};
          }
        }
      }
    }
  `}
`;
